<template>
  <div class="hr-report-wrapper">
    <iframe :src="iframeSrc"></iframe>
  </div>
</template>

<script>
import { HR_REPORT_CONFIG_DATA_TYPE } from '@/constant/common'

export default {
  props: {
    reportType: {
      type: String,
      required: true
    },
    configDataId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    iframeSrc () {
      let src = `/recruiter-pc/report/${this.reportType === HR_REPORT_CONFIG_DATA_TYPE.CHART ? 'data-chart' : 'dashboard'}/view/${this.configDataId}`
      if (process.env.VUE_APP_ENV === 'development') {
        // 本地开发时需要根据实际情况修改
        src = `http://localhost:8080${src}`
      }
      return src
    }
  },
  created () {

  },
  methods: {

  },
  watch: {
    '$i18n.locale' () {
      if (process.env.VUE_APP_ENV === 'development') {
        const el = this.$el?.firstElementChild
        el.remove()
        this.$nextTick(() => {
          this.$el.appendChild(el)
        })
      } else {
        this.$el?.firstElementChild.contentWindow.location.reload()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hr-report-wrapper {
  margin-bottom: 15px;
  border-radius: 6px;
  background: #ffffff;
  iframe {
    width: 100%;
    height: 690px;
    border: 0;
    outline: 0;
  }
}
</style>
